export enum OrderType {
    OrderRelease = 0,
    Quote,
    Shipment,
    Expense,
    Job,
    Leg
}